// Remaps report/screening statuses for candidate-facing display.
// `candidateFacingStatusEnabled` comes from the Harness flag
// `candidate_facing_status` (see HARNESS_FLAGS), evaluated per candidate
// email in the browser (useHarnessFlag) or on the Node server for the PDF
// render (serverHarnessFlag).
const candidateFacingStatus = (
  status,
  candidateFacingStatusEnabled = false,
) => {
  if (
    candidateFacingStatusEnabled &&
    (status === 'consider' || status === 'escalated' || status === 'review')
  ) {
    return 'complete';
  }

  if (status === 'paused') {
    return 'pending';
  }

  return status;
};

export default candidateFacingStatus;
